<template>
  <div class="flex items-center justify-center h-full flex-1">
    <div class="select-none">
      <h1 class="text-center" style="font-size: 160px">403</h1>
      <p class="text-center">У вас недостаточно прав для просмотра данной страницы</p>
    </div>

  </div>
</template>

<script>
  export default {
    name: "Forbidden"
  }
</script>